module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2659c05c51412f56c36a02beb5758cac.png";